import type { ColumnDef } from '@tanstack/react-table';
import type { ApiTokenApiTokenReadModel } from '@r/api/generated/client.schemas.ts';
import { useTranslation } from 'react-i18next';
import { Button } from '@ui/button.tsx';
import { Trash2Icon } from 'lucide-react';

type Token = ApiTokenApiTokenReadModel;

export const useTokenColumns = (
  confirmTokenDeletion: (token: Token) => void
): ColumnDef<Token>[] => {
  const { t } = useTranslation();

  return [
    {
      accessorKey: 'name',
      header: t('admin.api.token.column.name')
    },
    {
      accessorKey: 'createdAt',
      header: t('admin.api.token.column.created.at'),
      cell: ({ row }) => {
        return row.original.createdAt ? new Date(row.original.createdAt).toLocaleDateString() : '';
      }
    },
    {
      header: t('admin.api.token.column.expiration'),
      cell: () => {
        return t('admin.api.token.cell.expiration.never');
      }
    },
    {
      id: 'actions',
      cell: ({ row }) => (
        <Button
          variant={'raw'}
          className="float-right p-0 rounded-md text-destructive/60 hover:text-destructive h-fit"
          onClick={() => confirmTokenDeletion(row.original)}
        >
          <Trash2Icon size={20} />
        </Button>
      )
    }
  ];
};
